import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './assets/styles/main.css'; 
import AnimationComponent from './components/components/AnimationBg';

function App() {
  return (
    <Router>
      <AnimationComponent />
      <Header />
      <br/>
      <br/>
      <br/>
      <br/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <br/>
      <br/>
      <br/>
      <br/>
      <Footer />
    </Router>
  );
}

export default App;
